/**
 * Payment vocabulary shared with the browser. Kept apart from `payments.ts` so
 * the UI can name a method without dragging the database client into the client
 * bundle.
 */

export const PAYMENT_METHODS = ["upi", "bank_transfer", "other"] as const;
export type PaymentMethod = (typeof PAYMENT_METHODS)[number];

export const PAYMENT_METHOD_LABELS: Record<PaymentMethod, string> = {
  upi: "UPI",
  bank_transfer: "Bank transfer",
  other: "Other",
};

/** Screenshots are held in the database, so cap them well below any body limit. */
export const MAX_PROOF_BYTES = 5 * 1024 * 1024;
export const ALLOWED_PROOF_MIMES = ["image/png", "image/jpeg", "image/webp"] as const;

export type PayoutFields = {
  upiId: string | null;
  bankAccountNumber: string | null;
  bankIfsc: string | null;
  otherPayoutDetails?: string | null;
};

/**
 * Whether a creator can actually be paid. A bank account is only usable with
 * its IFSC, so a half-filled one counts for nothing. This is the single rule —
 * accepting an offer, the collab room and settings all defer to it.
 */
export function hasPayoutDetails(row: PayoutFields | null | undefined): boolean {
  if (!row) return false;
  return Boolean(
    row.upiId || (row.bankAccountNumber && row.bankIfsc) || row.otherPayoutDetails?.trim(),
  );
}
